import type { RouteRecordName } from '#vue-router'

export const crossPlatformRoutes: RouteRecordName[] = [
  'kundenkonto-userId-email-andern',
  'kundenkonto-userId-email-andern-anfrage',
  'kundenkonto-userId-email-andern-erfolg',
  'kundenkonto-userId-passwort-andern',
]
